(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/infobutton-text/assets/javascripts/react/infobutton-text.js') >= 0) return;  svs.modules.push('/components/lb-ui/infobutton-text/assets/javascripts/react/infobutton-text.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;

const ReactInfoButtonText = _ref => {
  let {
    className,
    isWhite,
    text,
    size,
    onClickFunction
  } = _ref;
  const classNamesLabel = ['pointer u-flex'];
  const classNamesButton = ['info-button-and-text'];
  const color = isWhite ? 'fc-white' : '';
  if (isWhite) {
    classNamesButton.push('f-inverted');
  }
  if (className) {
    classNamesLabel.push(className);
  }
  if (!size) {
    size = '300';
  }
  if (!text || text.length === 0) {
    text = '';
  }
  return React.createElement("label", {
    className: classNamesLabel.join(' ')
  }, React.createElement(IconButton, {
    className: classNamesButton.join(' '),
    onClick: onClickFunction
  }, React.createElement(Icon, {
    className: "margin-xs-right",
    color: color,
    icon: "information",
    size: size
  })), text && text.length > 0 && React.createElement("span", {
    className: "".concat(color),
    style: {
      verticalAlign: 'text-top'
    }
  }, text));
};
svs.tb_ui.ReactInfoButtonText = ReactInfoButtonText;

 })(window);